"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INSIDE = exports.OUTSIDE = exports.MIN_TIME_MOVE = exports.SLOW_ANIMATION = exports.FAST_ANIMATION = void 0;
var FAST_ANIMATION = 35;
exports.FAST_ANIMATION = FAST_ANIMATION;
var SLOW_ANIMATION = 400;
exports.SLOW_ANIMATION = SLOW_ANIMATION;
var MIN_TIME_MOVE = 150;
exports.MIN_TIME_MOVE = MIN_TIME_MOVE;
var OUTSIDE = 'outside';
exports.OUTSIDE = OUTSIDE;
var INSIDE = 'inside';
exports.INSIDE = INSIDE;